import { GetBasketUrl } from 'autogen/swagger/all';
import { PrizeCertificatesUrl } from 'autogen/swagger/all';
import { _LoginInfoUrl } from 'autogen/swagger/all';
import UpdateCheckoutContent from '../views/checkout/updateCheckoutContent';
import UpdateBasketFooter from '../views/basket/updateBasketFooter';
import mediator from './mediator';
import Translations from './translations';

let prizeCertificates;

export default class PrizeCertificate {
    static async update() {
        const node = $('[data-js="prizeCertificate"]');
        if (prizeCertificates) {
            prizeCertificates.abort();
        }

        if (node.length > 0) {
            prizeCertificates = $.get(PrizeCertificatesUrl, (data) => {
                node[0].outerHTML = data;
            });
        }
    }

    static bind(scope = $('body')) {
        scope.find('[data-js="prizeCertificate"]').each((i, item) => {
            const prizeCertificate = new PrizeCertificate($(item));
            prizeCertificate.init();
        });
    }

    init() {
        this.bindings();
    }

    bindings() {
        $(document).on('click', '[data-js-prize]', (event) => this.handlePost(event));
    }

    handlePost(event) {
        const target = event.currentTarget;
        const url = target.dataset.jsPrize;
        const isBasket = $(target).parents('[data-js="basket-footer"]').length > 0; // if we are not in the basket then we are on the delivery page

        $.ajax({
            url,
            type: 'POST'
        })
            .done((response) => {
                if (!response.success) {
                    // didn't work
                    mediator.publish('growl', {
                        message: Translations.Website.PrizeCertificate.ErrorOccurred,
                        remove: 2000
                    });
                } else if (isBasket) {
                    this.rebindBasketFooter();
                    mediator.publish('updateBasketPointInfoAdvantages');
                } else {
                    const logininfo = $.get(_LoginInfoUrl);
                    const basket = $.get(GetBasketUrl);

                    PrizeCertificate.update();

                    $.when(logininfo, basket).done((logininfoResponse, basketResponse) => {
                        (async () => {
                            const { updateBasket, updateLoginInfo } = await import('modules/form/input-form');
                            updateLoginInfo(logininfoResponse[0]);
                            updateBasket(basketResponse[0]);
                        })();
                    });
                }
            })
            .fail((err) => {
                console.log(err);
            });
    }

    rebindBasketFooter() {
        const updateBasketFooter = new UpdateBasketFooter();
        updateBasketFooter.updateBasketFooter();
    }

    updateCheckoutContent() {
        const updateCheckoutContent = new UpdateCheckoutContent();
        updateCheckoutContent.updateCheckoutContent();
        updateCheckoutContent.updateUserInfo();
    }
}
